var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "btn/exit@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,4.62131372 C8,3.52753859 8.97635735,2.83454815 9.88367097,3.0342188 C9.97480224,3.01857661 10.0681312,3.00799876 10.162992,3.00311506 L10.2843006,3 L19.4299851,3 C20.6507858,3 21.6480498,3.94228664 21.7111191,5.12777308 L21.7142857,5.2471065 L21.7142857,20.4671792 C21.7142857,21.6681022 20.7564024,22.6491283 19.5512938,22.7111707 L19.4299851,22.7142857 L16.571,22.714 L16.5714286,25.3787017 C16.5714286,26.7232429 15.0960588,27.4621598 14.0871476,26.681731 L13.9845211,26.5955398 L8.53154503,21.6349854 C8.19352942,21.3276273 8,20.8839105 8,20.4175755 L8.00417662,20.5536167 L8.00417662,20.5536167 L8,20.4671792 Z M9.824,5.669 L9.82475846,20.4671792 C9.82475846,20.5630592 9.80947522,20.6554278 9.78117447,20.742056 L14.8571429,25.2857143 L14.8571429,10.1744363 L9.824,5.669 Z M19.4299851,4.79504687 L12.115,4.795 L16.0407833,8.36584943 C16.3403625,8.63902669 16.5266317,9.01967214 16.5643264,9.4281231 L16.5714286,9.58244001 L16.571,20.919 L19.4299851,20.9192388 C19.6625506,20.9192388 19.8548891,20.749097 19.8853304,20.5285024 L19.8895273,20.4671792 L19.8895273,5.2471065 C19.8895273,5.01832781 19.7165692,4.82912105 19.4923233,4.79917534 L19.4299851,4.79504687 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn/exit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#1E1E1C",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.03c96d9f425ee8bad7e658358091f35c.svg";
export { ForwardRef as ReactComponent };